import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  const goToTest = (type) => {
    navigate(`/test/${type}`);
  };

  return (
    <div className="home-container">
      {/* 头部 */}
      <div className="hero-section">
        <h1 className="hero-title">依恋型人格测试</h1>
        <p className="hero-subtitle">了解你的爱情模式，收获更健康的亲密关系</p>
      </div>

      {/* 测试选择 */}
      <div className="test-selection-section">
        <div className="test-options">
          <div className="test-option-card recommended">
            <div className="card-badge">简版</div>
            <h3 className="card-title">快速测试</h3>
            <p className="card-desc">12题 · 约3分钟<br/>快速识别你的依恋倾向</p>
            <button className="card-button primary" onClick={() => goToTest('short')}>
              开始测试
            </button>
          </div>

          <div className="test-option-card">
            <div className="card-badge">详细</div>
            <h3 className="card-title">深度测试</h3>
            <p className="card-desc">36题 · 约5分钟<br/>深入分析你的依恋模式</p>
            <button className="card-button secondary" onClick={() => goToTest('full')}>
              开始测试
            </button>
          </div>
        </div>
      </div>

      {/* 测试介绍 */}
      <div className="intro-section">
        <div className="intro-content">
          <h2 className="intro-title">什么是依恋型人格测试？</h2>
          <p className="intro-text">
            依恋型人格测试帮助你了解在亲密关系中的情感模式，揭示你在恋爱或婚姻中的行为倾向。
          </p>
          <p className="intro-text">
            测试基于心理学依恋理论，测量<strong>"依恋焦虑"</strong>和<strong>"依恋回避"</strong>两个维度，得出四种依恋类型：安全型、焦虑型、回避型、恐惧型。
          </p>
          <div className="intro-note">
            基于《亲密关系经历量表》（ECR），由Brennan等人1998年开发，信度0.90以上，中文版经李同归等2006年验证，广泛用于心理学研究。
          </div>
        </div>
      </div>

      {/* 用户反馈 */}
      <div className="feedback-section">
        <h2 className="feedback-title">用户反馈</h2>
        <div className="feedback-grid">
          <div className="feedback-card">
            <div className="feedback-quote">"你的依恋风格让我明白了为什么在感情中总是这样。通过建议，我学会了更好地处理情绪，关系更稳定了。"</div>
            <div className="feedback-author">- 小雨，26岁，安全型</div>
          </div>

          <div className="feedback-card">
            <div className="feedback-quote">"原来我的焦虑倾向这么高！测试帮我认识到问题所在，现在我知道怎么调整自己的行为了。"</div>
            <div className="feedback-author">- 晓明，29岁，焦虑型</div>
          </div>
        </div>
      </div>

      {/* 底部 */}
      <div className="footer-section">
        <p className="footer-text">本测试仅供参考，不能替代专业心理咨询。<br/>如有严重情绪问题，请及时寻求专业帮助。</p>
        <p className="footer-disclaimer">© 2024 依恋型人格测试 | 基于科学心理学理论</p>
      </div>
    </div>
  );
};

export default Home;
